import { AnalyticsFeatureModule } from '@analytics/feature';
import { AnalyticsUiModule } from '@analytics/ui';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [AnalyticsFeatureModule, AnalyticsUiModule],
  exports: [AnalyticsUiModule],
})
export class AnalyticsShellModule {}
